/* SCC site polish: free-shipping meter (members ship free always) + short deck names in cart, search and stock cards. Display only. */
(function () {
  var T = (window.SCC && window.SCC.freeShip) || 3000;

  function money(c) { var s = (c / 100).toFixed(2); return '$' + (s.slice(-3) === '.00' ? s.slice(0, -3) : s); }

  /* same rules as snippets/scc-short-title.liquid */
  function shortTitle(t) {
    var pack = '';
    if (/12-Pack|Pack of 12|12 Pack/i.test(t)) pack = ' · 12-pack';
    else if (/2-Pack|Pack of 2\)|2 Pack/i.test(t)) pack = ' · 2-pack';
    var s = t.trim().replace(/^(The Shuffle Club Co\. |Shuffle Club Co\. |Shuffle Club Co |The Shuffle Club |Shuffle Club |The )/, '');
    var tail = s.split(' – ');
    s = s.split(' – ')[0].split(' | ')[0].split(' - ')[0].split(' (')[0].split('– ')[0];
    s = s.replace(' Premium Playing Cards', '').replace(' Playing Cards', '').replace(' Playing Card', '').replace(' Edition', '').replace(' Premium', '').trim();
    if ((s === 'Playing Cards' || !s) && tail.length > 1) s = tail[1].split(' | ')[0].replace(' Deck', '').replace(' Edition', '').trim();
    return (s || t) + pack;
  }
  window.sccShortTitle = shortTitle;

  var SEL = '.cart-item__name, .cart-notification-product__name, .card__heading > a, .card__heading.h5 > a, .predictive-search__item-heading, .scc-bar__name, .scc-buy__title';
  function shorten() {
    document.querySelectorAll(SEL).forEach(function (el) {
      if (el.closest('.scc-fd') || el.children.length) return;
      var full = el.textContent.trim();
      if (!/Shuffle Club|Playing Cards/i.test(full)) return;
      var s = shortTitle(full);
      if (s && s !== full) { el.textContent = s; el.setAttribute('title', full); }
    });
  }

  /* Club members and Deal Me In "Ten" holders ship free on every order (automatic discounts); a Club plan in the cart ships free too */
  function always(cart) {
    var a = window.SCC && window.SCC.freeShipAlways;
    if (a) return a;
    return (cart.items || []).some(function (i) { return i.selling_plan_allocation; }) ? 'plan' : '';
  }
  function freeBar(why) {
    var msg = why === 'club' ? 'Club member: <b>free shipping</b> on every order.' : why === 'ten' ? 'Your Ten of spades: <b>free shipping</b> on every order.' : 'Club plans ship <b>free</b>, every month.';
    return '<p class="scc-ship__msg">' + msg + '</p><div class="scc-ship__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="100"><span style="width:100%"></span></div>';
  }
  function bar(total) {
    var left = T - total, pct = Math.max(0, Math.min(100, Math.round((total / T) * 100)));
    var msg = left > 0
      ? 'You’re <b>' + money(left) + '</b> away from free US shipping.'
      : 'You’ve unlocked <b>free US shipping</b>.';
    return '<p class="scc-ship__msg">' + msg + '</p><div class="scc-ship__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><span style="width:' + pct + '%"></span></div>';
  }
  function mount() {
    var inner = document.querySelector('cart-drawer .drawer__inner');
    if (inner && !inner.querySelector('[data-scc-ship]')) {
      var head = inner.querySelector('.drawer__header');
      if (head) { var a = document.createElement('div'); a.className = 'scc-ship'; a.setAttribute('data-scc-ship', ''); head.insertAdjacentElement('afterend', a); }
    }
    var page = document.querySelector('#main-cart-items, cart-items:not(cart-drawer-items)');
    if (page && !page.closest('cart-drawer') && !document.querySelector('.scc-ship--page')) {
      var b = document.createElement('div'); b.className = 'scc-ship scc-ship--page page-width'; b.setAttribute('data-scc-ship', '');
      page.insertAdjacentElement('beforebegin', b);
    }
  }
  function paint(cart) {
    document.querySelectorAll('[data-scc-ship]').forEach(function (el) {
      if (!cart.item_count) { el.innerHTML = ''; return; }
      var why = always(cart);
      var ws = (cart.items || []).some(function (i) { return i.product_type === 'Wholesale Case'; });
      var club = (window.SCC && window.SCC.pages && window.SCC.pages.club) || '/pages/club';
      el.innerHTML = why ? freeBar(why) : bar(cart.total_price) + (ws ? '' : '<p class="scc-ship__club">Club members ship free and save 15% on every order. <a href="' + club + '">Deck of the Month, $12.99/mo with games included &rarr;</a></p>');
      el.classList.toggle('is-done', !!why || cart.total_price >= T);
    });
  }

  var timer, busy = false;
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      busy = true;
      mount(); shorten();
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(paint)
        .catch(function () {})
        .then(function () { setTimeout(function () { busy = false; }, 50); });
    }, 120);
  }

  function boot() {
    refresh();
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, refresh); } catch (e) {}
    }
    var mo = new MutationObserver(function (list) {
      if (busy) return;
      for (var i = 0; i < list.length; i++) {
        var t = list[i].target;
        if (t.nodeType === 1 && t.closest && t.closest('[data-scc-ship]')) continue;
        refresh(); return;
      }
    });
    var drawer = document.querySelector('cart-drawer');
    if (drawer) mo.observe(drawer, { childList: true, subtree: true });
    ['#cart-icon-bubble', '#predictive-search-results', 'main'].forEach(function (s) {
      var el = document.querySelector(s); if (el) mo.observe(el, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
